import {BEX_API_OPERATIONS} from '../constants/bexApiOperations';

export const isBexApiOperation = (operation) => {
    return BEX_API_OPERATIONS.includes(operation.operationName);
};
